<template>
  <div class="signBox">
    <ots-main-title :mainTopBtn="mainTopBtnList">
      <template v-slot:tabs>
        <el-tabs v-model="exportType" @tab-click="handleClick">
          <el-tab-pane label="考点模式" name="place"></el-tab-pane>
          <el-tab-pane label="场次模式" name="section"></el-tab-pane>
          <el-tab-pane label="教室模式" name="room"></el-tab-pane>
        </el-tabs>
      </template>
    </ots-main-title>
    <template v-if="canDownLoad">
      <ots-refer
        class="mb20"
        :request-form="selectParams"
        :selectList="selectList"
        @search="getResult"
      />
      <div class="mainCon">
        <ots-table-group
          style="width: 100%"
          :tableHeader="tableHeader"
          :tableOption="tableOption"
          :tableData="tableData"
          :pagination="pagination"
          @handleSelectionChange="bachOper"
          @changeNum="changeSize"
          @changePage="changePage"
        ></ots-table-group>
      </div>
    </template>
    <template v-else>
      <div class="mainCon">
        <img src="@/assets/img/signNull.png" class="mt180" />
        <span class="col_grayZ mt40">签到表正在生成中，请稍后...</span>
      </div>
    </template>
    <ots-custom-dialog :dialog.sync="downDialog" title="批量下载" width="40%">
      <template v-slot:content>
        <div class="exportDialog">
          <el-form>
            <el-form-item label="请选择数据范围">
              <el-radio-group v-model="downLoadParams.actionType">
                <el-radio-button :label="2">选中数据</el-radio-button>
                <el-radio-button :label="1">查询结果数据</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="downDialog = false">取消</el-button>
        <el-button round type="primary" @click="dowmLoadSignByParams"
          >确定</el-button
        >
      </template>
    </ots-custom-dialog>
  </div>
</template>

<script>
import { getCurrentPlanFn } from "@/http/modules/examSet/examBatch";
import {
  getSignSessionList,
  getSignPlaceList,
  getSignClassList,
  exportSign,
  getCurrentSelectSection,
  getCurrentSelectPlace,
} from "@/http/modules/examSet/planClass";
const pageType = ["section", "place", "room"];
export default {
  name: "signTable",
  data() {
    return {
      downDialog: false,
      canDownLoad: true,
      exportType: "place",
      changeBtnList: [
        {
          title: "批量下载",
          fn: this.showDialog,
        },
      ],
      changeSelectList: {
        place: [
          {
            title: "考点名称",
            type: "input",
            requestKey: "name",
          },
        ],
        section: [
          {
            title: "场次名称",
            type: "input",
            requestKey: "name",
          },
        ],
        room: [
          {
            title: "考点",
            type: "select",
            requestKey: "placeId",
            label: "name",
            value: "id",
            data: [],
          },
          {
            title: "场次",
            type: "select",
            requestKey: "sessionId",
            label: "name",
            value: "id",
            data: [],
          },
        ],
      },
      changeTableHeader: {
        place: [
          {
            title: "考点",
            prop: "name",
          },
          {
            title: "考试人数",
            prop: "count",
          },
          {
            title: "操作",
            type: "button",
            formatter: () => "下载",
            click: this.downLoadSign,
          },
        ],
        section: [
          {
            title: "场次",
            prop: "name",
          },
          {
            title: "考试人数",
            prop: "count",
          },
          {
            title: "操作",
            type: "button",
            formatter: () => "下载",
            click: this.downLoadSign,
          },
        ],
        room: [
          {
            title: "考点",
            prop: "placeName",
          },
          {
            title: "教室",
            prop: "name",
          },
          {
            title: "场次",
            prop: "sessionName",
          },
          {
            title: "考试人数",
            prop: "count",
          },
          {
            title: "操作",
            type: "button",
            formatter: () => "下载",
            click: this.downLoadSign,
          },
        ],
      },
      selectParams: {
        planId: "",
        sessionId: "",
        name: "",
        page: 1,
        size: 10,
      },
      tableData: [],
      pagination: {
        total: 0,
      },
      tableOption: {
        multiple: true,
      },
      downLoadParams: {
        actionType: 2, //1查询结果2勾选结果
        ids: "",
        name: "",
        placeId: "",
        queryType: 2, //1场次列表2考点列表3考场列表
        sessionId: "",
      },
    };
  },
  computed: {
    mainTopBtnList() {
      return this.canDownLoad ? this.changeBtnList : [];
    },
    selectList() {
      return this.changeSelectList[this.exportType];
    },
    tableHeader() {
      return this.changeTableHeader[this.exportType];
    },
  },
  watch: {
    exportType: {
      handler: function(val) {
        this.selectParams.name = "";

        this.getResult();
        this.downLoadParams.queryType =
          pageType.findIndex((item) => val == item) + 1;
      },
      immediate: true,
    },
  },
  created() {
    this.selectParams.planId = this.$route.query.planId;
    this.getPlanInfo();
    this.getResult();
  },
  methods: {
    async getPlanInfo() {
      let { data } = await getCurrentPlanFn({
        planId: this.$route.query.planId,
      });
      let { isCreateSignTable, id } = data;
      this.canDownLoad = isCreateSignTable == 1 ? true : false;

      this.initRoomRefer(id);
    },
    initRoomRefer(id) {
      // 场次
      getCurrentSelectSection({ planId: id }).then(({ data }) => {
        this.changeSelectList.room[1].data = data;
      });
      // 考点
      getCurrentSelectPlace({ planId: id }).then(({ data }) => {
        this.changeSelectList.room[0].data = data;
      });
    },
    getTableList() {
      if (this.exportType == "section") {
        this.dealSession();
      } else if (this.exportType == "room") {
        this.dealRoom();
      } else {
        // 考点
        this.dealPlace();
      }
    },
    async dealSession() {
      const { data } = await getSignSessionList(this.selectParams);
      this.tableData = data && data.records ? data.records : [];
      this.pagination.total = data && data.total ? data.total : 0;
    },
    async dealPlace() {
      if (this.selectParams.planId) {
        const { data } = await getSignPlaceList(this.selectParams);
        this.tableData = data && data.records ? data.records : [];
        this.pagination.total = data && data.total ? data.total : 0;
      }
    },
    async dealRoom() {
      if (!this.selectParams.placeId) {
        this.$message.warning("请先选择考点");
        this.tableData = [];
        this.pagination.total = 0;
        return;
      }
      const { data } = await getSignClassList(this.selectParams);
      this.tableData = data && data.records ? data.records : [];
      this.pagination.total = data && data.total ? data.total : 0;
    },
    changeSize(num) {
      this.selectParams.size = num;
      this.getTableList();
    },
    changePage(p) {
      this.selectParams.page = p;
      this.getTableList();
    },
    getResult() {
      this.selectParams.page = 1;
      this.getTableList();
    },
    downLoadSign(row) {
      window.open(row.address);
    },
    async dowmLoadSignByParams() {
      if (this.downLoadParams.actionType == 2 && !this.downLoadParams.ids) {
        this.$message.error("请勾选要下载数据");
        this.downDialog = false;
        return;
      }
      this.downLoadParams = Object.assign(
        this.downLoadParams,
        this.selectParams
      );
      const { data } = await exportSign(this.downLoadParams);
      if (data) {
        window.open(data);
        this.downDialog = false;
      }
    },
    showDialog() {
      this.downDialog = true;
    },
    bachOper(val) {
      let idList = [];
      val.forEach((item) => {
        idList.push(item.id);
      });
      this.downLoadParams.ids = idList.join();
    },
    handleClick() {
      console.log(this.exportType);
    },
  },
};
</script>

<style scoped lang="less">
.signBox {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  justify-content: space-between;
}
.mainCon {
  padding: 20px;
  height: 100vh;
  border-radius: 8px;
  background-color: #fff;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
/deep/ .el-tabs__item {
  font-size: 18px;
  color: #737780;
}
/deep/ .el-tabs__item.is-active {
  color: #2d2f33;
  font-weight: 500;
}
/deep/ .el-tabs__header {
  margin: 0;
}
/deep/ .el-tabs__content {
  display: none;
}

/* 考场安排/签到表下载 -> el-tabs 下划线修改处 */
/deep/ .el-tabs__nav-wrap::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2 px;
  background-color: transparent;
  z-index: 1;
}
</style>
